import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { JourneyFeaturesConfig } from '@ren/infrastructure/configs/journey-features.config';
import { RouteActivateGuard } from './services/guard/route-guard.service';

const routes: Routes = [
  {
    path: `${JourneyFeaturesConfig.retrieveQuote.path}/:token`,
    loadChildren: () =>
      import('../features/retrieve-quote/retrieve-quote.module').then(
        (m) => m.RetrieveQuoteModule
      ),
  },
  {
    path: `${JourneyFeaturesConfig.loadQuote.path}/:token`,
    loadChildren: () =>
      import('../features/retrieve-quote/retrieve-quote.module').then(
        (m) => m.RetrieveQuoteModule
      ),
  },
  {
    path: `${JourneyFeaturesConfig.loadQuote.path}`,
    loadChildren: () =>
      import('../features/retrieve-quote/retrieve-quote.module').then(
        (m) => m.RetrieveQuoteModule
      ),
  },
  {
    path: `${JourneyFeaturesConfig.lapsedRenewal.path}`,
    loadChildren: () =>
      import('../features/lapsed-renewal/lapsed-renewal.module').then(
        (m) => m.LapsedRenewalModule
      ),
    canActivate: [RouteActivateGuard],
  },
  {
    path: `${JourneyFeaturesConfig.stopYourRenewal.path}`,
    loadChildren: () =>
      import('../features/stop-renewal/stop-renewal.module').then(
        (m) => m.StopRenewalModule
      ),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.dashboard.path,
    loadChildren: () =>
      import('../features/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.yourCar.path,
    loadChildren: () =>
      import('../features/your-car/your-car.module').then(
        (m) => m.YourCarModule
      ),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.yourRegistration.path,
    loadChildren: () =>
      import('../features/your-registration/your-registration.module').then(
        (m) => m.YourRegistrationModule
      ),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.yourAddresses.path,
    loadChildren: () =>
      import('../features/your-addresses/your-addresses.module').then(
        (m) => m.YourAddressesModule
      ),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.yourDrivers.path,
    loadChildren: () =>
      import('../features/your-drivers/your-drivers.module').then(
        (m) => m.YourDriversModule
      ),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.yourDetails.path,
    loadChildren: () =>
      import('../features/your-details/your-details.module').then(
        (m) => m.YourDetailsModule
      ),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.yourMileage.path,
    loadChildren: () =>
      import('../features/your-mileage/your-mileage.module').then(
        (m) => m.YourMileageModule
      ),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.yourVehicleUsage.path,
    loadChildren: () =>
      import('../features/your-vehicle-usage/your-vehicle-usage.module').then(
        (m) => m.YourVehicleUsageModule
      ),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.whereIParkMyCar.path,
    loadChildren: () =>
      import('../features/where-ipark-my-car/where-ipark-my-car.module').then(
        (m) => m.WhereIParkMyCarModule
      ),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.premium.path,
    loadChildren: () =>
      import('../features/premium/premium.module').then((m) => m.PremiumModule),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.review.path,
    loadChildren: () =>
      import('../features/review/review.module').then((m) => m.ReviewModule),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.payment.path,
    loadChildren: () =>
      import('../features/payment/payment.module').then((m) => m.PaymentModule),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.confirm.path,
    loadChildren: () =>
      import('../features/confirm/confirm.module').then((m) => m.ConfirmModule),
    canActivate: [RouteActivateGuard],
  },
  {
    path: JourneyFeaturesConfig.errors.path,
    loadChildren: () =>
      import('../features/errors/errors.module').then((m) => m.ErrorsModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class MainRoutingModule {}
